import { useState, useEffect } from 'react';

export const useInstallPrompt = () => {
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const getStoredPrompt = () => window.__mdDeferredInstallPrompt || null;
    // Detect iOS
    const userAgent = window.navigator.userAgent.toLowerCase();
    const iosMatch = /iphone|ipad|ipod/.test(userAgent);
    const isStandalone =
      window.navigator.standalone === true ||
      window.matchMedia?.('(display-mode: standalone)').matches === true;

    setIsIOS(iosMatch);
    setIsInstalled(isStandalone);
    setInstallPrompt(getStoredPrompt());

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      window.__mdDeferredInstallPrompt = e;
      setInstallPrompt(e);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      window.__mdDeferredInstallPrompt = null;
      setInstallPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const install = async () => {
    if (!installPrompt) return;

    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    
    if (outcome === 'accepted') {
      window.__mdDeferredInstallPrompt = null;
      setInstallPrompt(null);
    }
  };

  return {
    installPrompt,
    isIOS,
    isInstalled,
    canInstall: Boolean(installPrompt),
    install,
  };
};
